import App from './App.svelte';

const app = new App({
	target: document.querySelector('#svelte-app'),
	intro: true
	
});

export default app;